import {
    get2,
    post2,
    url,
} from "../http"

class Login {
    // 获取图形验证码
    @url('/auth/user/captcha')
    @get2
    getCpatcha() { }

    // 账号密码登录
    @url('/auth/user/pcLogin')
    @post2
    login() { }

    // 手机号登录
    @url("/auth/user/loginByPhone")
    @post2
    loginByPhone() { }

    //发送手机验证码
    @url("/auth/user/phone/send_code")
    @post2
    getVerifyCode() { }

    // 验证手机验证码
    @url("/auth/user/phone/check")
    @post2
    checkCode() { }

    // 用户信息
    @url('/auth/user/info')
    @get2
    userInfo() { }

    // 获取跳转空中课堂code
    @url('/auth/third/getIdentifying')
    @post2
    getCode() { }

    // 获取多账户列表
    @url('/auth/user/queryMember')
    @get2
    getRealNameList() { }

    // 获取多账户选择后的账户token
    @url('/auth/user/queryMemberToken')
    @post2
    getMemberToken() { }

    // 获取完善资料option
    @url('/auth/smartEdu/login/getOption')
    @get2
    getOptionCloud() { }

    // 教育云-查看是否完善信息
    @url('/auth/smartEdu/login/getBindInfo')
    @get2
    getBindInfo() { }

    // 教育云-完善信息
    @url('/auth/smartEdu/login/improveInfo')
    @post2
    improveInfoCloud() { }

    // 是否是虚拟账号
    @url('/auth/virtual/login/isVirtual')
    @post2
    isVirtua() { }

    // 虚拟账号登录
    @url('/auth/virtual/login/vpclogin')
    @post2
    vpclogin() { }

    // 虚拟账号完善信息
    @url('/auth/virtual/login/improveInfo')
    @post2
    improveInfo() { }

    // 虚拟账号修改密码
    @url('/auth/virtual/login/changePwd')
    @post2
    vchangePwd() { }

    // 虚拟账号获取信息选项
    @url('/auth/virtual/login/getOption')
    @get2
    getOption() { }
    // 获取CA登录跳转地址 
    @url('/auth/user/third/getCaUrl')
    @get2
    getCaUrl() { }
    // CA登录
    @url('/auth/third/ca/login')
    @post2
    calogin() { }
    // CA登录(新版)
    @url('/auth/user/third/ca/login2')
    @get2
    newcalogin() { }
    //资源圈 -- 获取文件token
    @url('/fu/center/queryToken')
    @get2
    getFileToken() { }
    // 获取省市区下面的学校
    @url('/auth/smartEdu/login/getSchoolOption')
    @get2
    getSchoolOption() { }
    // CA登录完善信息
    @url('/auth/smartEdu/login/getOptionBj')
    @get2
    getOptionCA() { }
}

export default new Login()